module.exports = __webpack_public_path__ + "img/cloud-figure.51f71dd6.png";